module.exports = __webpack_public_path__ + "img/icono_social_studies.0157ea2c.svg";